import { useTranslation } from 'react-i18next';
import { Badge } from '@brainsway/ui';
import type { ReportStatus } from '../types';

const STATUS_MAP: Record<ReportStatus, 'default' | 'warning' | 'success' | 'error'> = {
  DRAFT: 'default',
  SUBMITTED: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
};

interface StatusBadgeProps {
  status: ReportStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();
  return <Badge variant={STATUS_MAP[status]}>{t(`status.${status.toLowerCase()}`)}</Badge>;
}
